<template>
  <div class="questionnaire-item-question">
    <div class="questionnaire-item-question-text">{{question.text}}</div>

    <div>
      <QuestionnaireField
        v-for="field in question.fields" :key="field.id"
        v-on:toggle-field="toggleField"
        v-on:update-value="updateField"
        :field="field" />
    </div>
  </div>
</template>

<script>
  import QuestionnaireField from './Field';

  export default {
    name: 'QuestionnaireQuestion',

    components: {QuestionnaireField},

    props: ['question'],

    data() {
      return {
        answers: [],
      };
    },

    created() {
      this.answers = this.question.answers.map(
        ({ field, value }) => ({ field, value })
      );
    },

    methods: {
      toggleField(fieldData) {
        const { field, value } = fieldData;

        if (!this.question.multiple) {
          this.answers = [{ field, value }];
        } else {
          const inFields = this.answers.find(f => field === f.field);

          if (inFields) {
            this.answers = this.answers.filter(f => field !== f.field);
          } else {
            this.answers.push({ field, value });
          }
        }

        this.updateFields();
      },

      updateField(fieldData) {
        const { field, value } = fieldData;
        const updatedField = this.answers.find(f => field === f.field);

        if (!updatedField) {
          return this.toggleField(fieldData);
        }

        updatedField.value = value;

        this.updateFields();
      },

      updateFields() {
        const questionData = {
          questionId:this.question.id,
          fields: this.answers,
        };

        this.$emit('update-fields', questionData);
      },
    },
  }
</script>

<style lang="scss">
  @import "../../assets/scss/variables.scss";

  .questionnaire-item-question {
    .questionnaire-item-question-text {
      position: relative;
      padding: 10px 20px;
      font-weight: bold;
      font-size: 12px;
      text-transform: uppercase;
      color: $primary;
      background-color: $light-gray-bg;
      border-top: 2px solid $primary;
    }
  }
</style>
